export default __webpack_public_path__ + "static/toolSelection-fbc1367cb7cd785d936c338790427f1a.svg";